import { Card, Dialog, DialogTitle, Grid, IconButton, duration } from '@mui/material';
import styles from '../contactus.module.scss'
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import SendEmail from './sendEmail';
import toast from 'react-hot-toast';
import ToastError from '../../common/toast/toastError';
import { apiRequest, authService, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import { isNil } from 'lodash';
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from '../../common/ErrorPopup';
import constants from "../../../config/constants.json";

const ExecutiveCommitteeMember = () => {
    const [itemData, setItemData] = useState<any[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedName, setSelectedName] = useState<string>("");
  const [toEmail, setToEmail] = useState<string>("");
  const [commiteeName, setCommiteeName] = useState<string>("");
    useEffect(() => {
        apiRequest({
            method: 'GET',
            endpoint: apiPath.managementTeamMemberECApi,
            params: {
                category: "EC"
            },
            // includeToken: true
        })
            .then((res) => {
                console.log(res.data, "excuetive");
                setItemData(res.data);
                //   setDonationHistoryData(res.data.content);
            })
            .catch((err) => {
                console.log(err);
 
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                  });
            });
    }, []);

    const handleClose = (): void => {
        setIsOpen(false);
        setSelectedName("");
        setToEmail("");
        setCommiteeName("");
      };
    
      const handleClick = (item: any) => {
        setIsOpen(authService.isAuthenticated());
        setSelectedName(item.fullname);
        setToEmail(item.email);
        setCommiteeName(item.committee);
      };

    return (
        <>
            <div className={styles.ExecutiveCommitteeMemberLayout}>
                <div style={{ marginTop: "30px" }}>
                    <Grid sx={{ marginTop: "20px" }} className={styles.cardContainer}>
                        <table className={styles.tableContainer}>
                            <thead>
                                <tr className={styles.headerTableRow}>
                                    <th className={styles.tableHorizontal}>Member Name</th>
                                    <th className={styles.tableHorizontal}>Committee</th>
                                    <th className={styles.tableHorizontal}>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemData.map((item, index) => (
                                    <tr key={index} className={styles.tableRow}>
                                        <td className={styles.tableDiagonal}>
                                            <div onClick={() => { handleClick(item); }}
                                                style={{ color: "#F05802", cursor: "pointer" }}
                                            >
                                                {item.fullname}
                                            </div>
                                        </td>
                                        <td className={styles.tableDiagonal}>{item.committee}</td>
                                        <td className={styles.tableDiagonal}>{item.email}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Grid>
                </div>
                <Grid>
                    <div className={styles.scrollbar}>
                        <Dialog
                            open={isOpen}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            maxWidth="xl"
                            PaperProps={{
                                style: {
                                    maxWidth: '759px',
                                    // height: 'calc(100% - 64px)',
                                    margin: '32px',
                                    borderRadius: '16px',
                                    background: '#FFF',
                                    maxHeight: '700px',
                                    flexDirection: "column"
                                },
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#882E14',
                                    height: "66px",
                                    borderTopRightRadius: "12px",
                                    borderTopLeftRadius: "12px",
                                }}
                            >
                                <DialogTitle sx={{ fontWeight: 600, fontSize: "24px", color: "white" }}>
                                    {'Send E-mail'}
                                </DialogTitle>
                                <IconButton
                                    aria-label="close"
                                    onClick={handleClose}
                                    sx={{
                                        position: 'absolute',
                                        right: 24,
                                        top: 16,
                                        color: (theme: any) => theme.palette.grey[500],
                                    }}
                                >
                                    <CloseIcon sx={{ color: 'white' }} />
                                </IconButton>
                            </div>
                            <div style={{ overflowY: 'auto', flex: 1 }}>
                                <SendEmail handleClose={handleClose} selectedName={selectedName} toEmail={toEmail} commiteeName={commiteeName}/>
                            </div>
                        </Dialog>
                    </div>
                </Grid>
            </div>
        </>
    )
}
export default ExecutiveCommitteeMember;
